// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__27nXb","header":"PatientQuestionnaire_header__1fHCt","info":"PatientQuestionnaire_info__2G7Ba"};